import {Button, Group, Modal, SimpleGrid, Stack, TextInput} from '@mantine/core';
import React, {useState} from 'react';

import {ChemicalCounterpartItem} from 'chemistry/ChemicalCounterpartLibrary';
import notifications from 'notifications';
import ModalFooter from 'ui-library/modals/ModalFooter';
import {capitalize} from 'util/NameUtil';
import {withLoadingScreen} from 'util/Promises';

export interface EditChemicalCounterpartModalProps {
  counterpartName: string;
  item: ChemicalCounterpartItem;
  onClose: () => void;
  onEdit: (id: string, name: string, code: string) => Promise<void>;
}

export default function EditChemicalCounterpartModal({
  counterpartName,
  item,
  onClose,
  onEdit,
}: EditChemicalCounterpartModalProps): JSX.Element {
  const [name, setName] = useState(item.name);
  const [code, setCode] = useState(item.code ?? '');

  const trimmedName = name.trim();
  const trimmedCode = code.trim();
  const isNameValid = trimmedName.length > 0;
  const hasChanged = trimmedName !== item.name || trimmedCode !== (item.code ?? '');

  return (
    <Modal title={`Edit ${counterpartName}`} opened={true} onClose={onClose} size="md">
      <Stack>
        <SimpleGrid cols={2}>
          <TextInput
            autoFocus={true}
            label="Name"
            required={true}
            value={name}
            placeholder="Name"
            onChange={(e) => {
              setName(e.target.value);
            }}
          />
          <TextInput
            label="Code"
            value={code}
            placeholder="Code"
            onChange={(e) => {
              setCode(e.target.value);
            }}
          />
        </SimpleGrid>
        <ModalFooter>
          <Group position="right">
            <Button type="button" onClick={onClose} variant="secondary">
              Cancel
            </Button>
            <Button
              type="submit"
              disabled={!isNameValid || !hasChanged}
              onClick={async () => {
                await withLoadingScreen(onEdit(item.id, name, code));
                notifications.success(`${capitalize(counterpartName)} "${name}" updated successfully`);
                onClose();
              }}
            >
              Save
            </Button>
          </Group>
        </ModalFooter>
      </Stack>
    </Modal>
  );
}
